// extracted by mini-css-extract-plugin
module.exports = {"wide":"PurposeStep_wide__1pLCg","purposeButton":"PurposeStep_purposeButton__QS4Up","disclaimer":"PurposeStep_disclaimer__2LTQh"};